import React from 'react';
import { Link } from 'react-router-dom';
import { TicketIcon, CheckCircleIcon, ArrowRightIcon, UsersIcon, BarChart2Icon, CreditCardIcon, SmartphoneIcon, QrCodeIcon, TagIcon, MailIcon, CalendarIcon, ShieldIcon } from 'lucide-react';
const TicketingServices = () => {
  return <div className="pb-16" data-id="element-3479">
      <div className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800" data-id="element-3480">
        <div className="max-w-4xl mx-auto p-4" data-id="element-3481">
          <h1 className="text-2xl font-bold mb-2 flex items-center" data-id="element-3482">
            <TicketIcon className="w-6 h-6 mr-2" data-id="element-3483" />
            Event Ticketing Solutions
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-3484">
            Powerful and affordable ticketing services for event organizers
          </p>
        </div>
      </div>
      <div className="max-w-4xl mx-auto p-4" data-id="element-3485">
        {/* Hero Section */}
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden mb-8" data-id="element-3486">
          <div className="h-48 bg-gray-200 dark:bg-gray-700 border-b border-gray-300 dark:border-gray-600 flex items-center justify-center" data-id="element-3487">
            <div className="text-center p-6" data-id="element-3488">
              <h2 className="text-xl font-bold mb-2" data-id="element-3489">
                Simplify Your Event Ticketing
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-3490">
                Sell tickets, manage attendees, and grow your events with
                JoinToday's ticketing platform
              </p>
              <div className="flex justify-center" data-id="element-3491">
                <Link to="/register" className="px-4 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md mr-3" data-id="element-3492">
                  Start Selling Tickets
                </Link>
                <a href="https://wa.me/254100254254" target="_blank" rel="noopener noreferrer" className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-3493">
                  Talk to Sales
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* Features */}
        <h2 className="text-xl font-bold mb-4" data-id="element-3494">Features & Benefits</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-3495">
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3496">
            <div className="flex items-center mb-4" data-id="element-3497">
              <QrCodeIcon className="w-8 h-8 mr-3" data-id="element-3498" />
              <h3 className="text-lg font-bold" data-id="element-3499">Mobile Tickets & QR Codes</h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-3500">
              Provide a seamless experience with digital tickets and secure QR
              code check-in.
            </p>
            <ul className="space-y-2" data-id="element-3501">
              <li className="flex items-start" data-id="element-3502">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3503" />
                <span className="text-sm" data-id="element-3504">
                  Instant ticket delivery via email and SMS
                </span>
              </li>
              <li className="flex items-start" data-id="element-3505">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3506" />
                <span className="text-sm" data-id="element-3507">
                  Fast check-in with QR code scanning
                </span>
              </li>
              <li className="flex items-start" data-id="element-3508">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3509" />
                <span className="text-sm" data-id="element-3510">
                  Reduce fraud with unique, encrypted tickets
                </span>
              </li>
            </ul>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3511">
            <div className="flex items-center mb-4" data-id="element-3512">
              <TagIcon className="w-8 h-8 mr-3" data-id="element-3513" />
              <h3 className="text-lg font-bold" data-id="element-3514">Flexible Ticket Types</h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-3515">
              Create multiple ticket options to maximize sales and meet diverse
              attendee needs.
            </p>
            <ul className="space-y-2" data-id="element-3516">
              <li className="flex items-start" data-id="element-3517">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3518" />
                <span className="text-sm" data-id="element-3519">
                  Early bird, regular, and VIP tickets
                </span>
              </li>
              <li className="flex items-start" data-id="element-3520">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3521" />
                <span className="text-sm" data-id="element-3522">
                  Time-limited promotional tickets
                </span>
              </li>
              <li className="flex items-start" data-id="element-3523">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3524" />
                <span className="text-sm" data-id="element-3525">
                  Group discounts and package deals
                </span>
              </li>
            </ul>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3526">
            <div className="flex items-center mb-4" data-id="element-3527">
              <CreditCardIcon className="w-8 h-8 mr-3" data-id="element-3528" />
              <h3 className="text-lg font-bold" data-id="element-3529">Secure Payment Processing</h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-3530">
              Accept payments with confidence through our trusted payment
              system.
            </p>
            <ul className="space-y-2" data-id="element-3531">
              <li className="flex items-start" data-id="element-3532">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3533" />
                <span className="text-sm" data-id="element-3534">
                  M-Pesa integration for local payments
                </span>
              </li>
              <li className="flex items-start" data-id="element-3535">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3536" />
                <span className="text-sm" data-id="element-3537">Credit/debit card processing</span>
              </li>
              <li className="flex items-start" data-id="element-3538">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3539" />
                <span className="text-sm" data-id="element-3540">
                  Fast and reliable payouts to your account
                </span>
              </li>
            </ul>
          </div>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3541">
            <div className="flex items-center mb-4" data-id="element-3542">
              <BarChart2Icon className="w-8 h-8 mr-3" data-id="element-3543" />
              <h3 className="text-lg font-bold" data-id="element-3544">Real-time Analytics</h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-3545">
              Track sales and attendance with powerful reporting tools.
            </p>
            <ul className="space-y-2" data-id="element-3546">
              <li className="flex items-start" data-id="element-3547">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3548" />
                <span className="text-sm" data-id="element-3549">
                  Live sales dashboard and reports
                </span>
              </li>
              <li className="flex items-start" data-id="element-3550">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3551" />
                <span className="text-sm" data-id="element-3552">
                  Attendee demographics and insights
                </span>
              </li>
              <li className="flex items-start" data-id="element-3553">
                <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3554" />
                <span className="text-sm" data-id="element-3555">
                  Export data for further analysis
                </span>
              </li>
            </ul>
          </div>
        </div>
        {/* How It Works */}
        <div className="mb-8" data-id="element-3556">
          <h2 className="text-xl font-bold mb-4" data-id="element-3557">How It Works</h2>
          <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3558">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3559">
              <div className="text-center" data-id="element-3560">
                <div className="w-12 h-12 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-3561">
                  <span className="text-xl font-bold" data-id="element-3562">1</span>
                </div>
                <h3 className="font-bold mb-2" data-id="element-3563">Create Your Event</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3564">
                  Set up your event details, ticket types, and pricing through
                  our easy-to-use platform.
                </p>
              </div>
              <div className="text-center" data-id="element-3565">
                <div className="w-12 h-12 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-3566">
                  <span className="text-xl font-bold" data-id="element-3567">2</span>
                </div>
                <h3 className="font-bold mb-2" data-id="element-3568">Sell Tickets</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3569">
                  Share your event page and watch as tickets are sold
                  automatically through our system.
                </p>
              </div>
              <div className="text-center" data-id="element-3570">
                <div className="w-12 h-12 bg-gray-100 dark:bg-gray-700 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-3571">
                  <span className="text-xl font-bold" data-id="element-3572">3</span>
                </div>
                <h3 className="font-bold mb-2" data-id="element-3573">Manage Your Event</h3>
                <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3574">
                  Check in attendees, track sales, and receive payments directly
                  to your account.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Pricing */}
        <div className="mb-8" data-id="element-3575">
          <h2 className="text-xl font-bold mb-4" data-id="element-3576">Pricing Plans</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-3577">
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-3578">
              <div className="bg-gray-100 dark:bg-gray-700 p-4 text-center border-b border-gray-300 dark:border-gray-600" data-id="element-3579">
                <h3 className="font-bold text-lg" data-id="element-3580">Basic</h3>
                <div className="mt-2" data-id="element-3581">
                  <span className="text-2xl font-bold" data-id="element-3582">5%</span>
                  <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3583">
                    {' '}
                    per ticket
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-3584">
                  + KES 50 fee per transaction
                </p>
              </div>
              <div className="p-4" data-id="element-3585">
                <ul className="space-y-2 mb-4" data-id="element-3586">
                  <li className="flex items-start" data-id="element-3587">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3588" />
                    <span className="text-sm" data-id="element-3589">Up to 100 tickets</span>
                  </li>
                  <li className="flex items-start" data-id="element-3590">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3591" />
                    <span className="text-sm" data-id="element-3592">Basic analytics</span>
                  </li>
                  <li className="flex items-start" data-id="element-3593">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3594" />
                    <span className="text-sm" data-id="element-3595">Email support</span>
                  </li>
                  <li className="flex items-start" data-id="element-3596">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3597" />
                    <span className="text-sm" data-id="element-3598">M-Pesa integration</span>
                  </li>
                </ul>
                <Link to="/register" className="block text-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-3599">
                  Choose Basic
                </Link>
              </div>
            </div>
            <div className="border-2 border-gray-800 dark:border-gray-200 rounded-lg overflow-hidden relative" data-id="element-3600">
              <div className="absolute top-0 right-0 bg-gray-800 dark:bg-gray-200 text-white dark:text-gray-800 text-xs px-2 py-1" data-id="element-3601">
                Popular
              </div>
              <div className="bg-gray-100 dark:bg-gray-700 p-4 text-center border-b border-gray-300 dark:border-gray-600" data-id="element-3602">
                <h3 className="font-bold text-lg" data-id="element-3603">Standard</h3>
                <div className="mt-2" data-id="element-3604">
                  <span className="text-2xl font-bold" data-id="element-3605">3.5%</span>
                  <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3606">
                    {' '}
                    per ticket
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-3607">
                  + KES 40 fee per transaction
                </p>
              </div>
              <div className="p-4" data-id="element-3608">
                <ul className="space-y-2 mb-4" data-id="element-3609">
                  <li className="flex items-start" data-id="element-3610">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3611" />
                    <span className="text-sm" data-id="element-3612">Up to 500 tickets</span>
                  </li>
                  <li className="flex items-start" data-id="element-3613">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3614" />
                    <span className="text-sm" data-id="element-3615">Advanced analytics</span>
                  </li>
                  <li className="flex items-start" data-id="element-3616">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3617" />
                    <span className="text-sm" data-id="element-3618">Priority email support</span>
                  </li>
                  <li className="flex items-start" data-id="element-3619">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3620" />
                    <span className="text-sm" data-id="element-3621">M-Pesa & card payments</span>
                  </li>
                  <li className="flex items-start" data-id="element-3622">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3623" />
                    <span className="text-sm" data-id="element-3624">Custom branding</span>
                  </li>
                </ul>
                <Link to="/register" className="block text-center px-4 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md" data-id="element-3625">
                  Choose Standard
                </Link>
              </div>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden" data-id="element-3626">
              <div className="bg-gray-100 dark:bg-gray-700 p-4 text-center border-b border-gray-300 dark:border-gray-600" data-id="element-3627">
                <h3 className="font-bold text-lg" data-id="element-3628">Premium</h3>
                <div className="mt-2" data-id="element-3629">
                  <span className="text-2xl font-bold" data-id="element-3630">2.5%</span>
                  <span className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3631">
                    {' '}
                    per ticket
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-3632">
                  + KES 30 fee per transaction
                </p>
              </div>
              <div className="p-4" data-id="element-3633">
                <ul className="space-y-2 mb-4" data-id="element-3634">
                  <li className="flex items-start" data-id="element-3635">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3636" />
                    <span className="text-sm" data-id="element-3637">Unlimited tickets</span>
                  </li>
                  <li className="flex items-start" data-id="element-3638">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3639" />
                    <span className="text-sm" data-id="element-3640">Comprehensive analytics</span>
                  </li>
                  <li className="flex items-start" data-id="element-3641">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3642" />
                    <span className="text-sm" data-id="element-3643">24/7 phone & email support</span>
                  </li>
                  <li className="flex items-start" data-id="element-3644">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3645" />
                    <span className="text-sm" data-id="element-3646">All payment methods</span>
                  </li>
                  <li className="flex items-start" data-id="element-3647">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3648" />
                    <span className="text-sm" data-id="element-3649">White-label solution</span>
                  </li>
                  <li className="flex items-start" data-id="element-3650">
                    <CheckCircleIcon className="w-4 h-4 mr-2 mt-0.5" data-id="element-3651" />
                    <span className="text-sm" data-id="element-3652">Dedicated account manager</span>
                  </li>
                </ul>
                <Link to="/register" className="block text-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700" data-id="element-3653">
                  Choose Premium
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* Testimonials */}
        <div className="mb-8" data-id="element-3654">
          <h2 className="text-xl font-bold mb-4" data-id="element-3655">What Our Clients Say</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3656">
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3657">
              <div className="flex items-start" data-id="element-3658">
                <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3659">
                  <span className="text-lg font-bold" data-id="element-3660">MF</span>
                </div>
                <div data-id="element-3661">
                  <h3 className="font-bold mb-1" data-id="element-3662">Mombasa Food Festival</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-3663">
                    "JoinToday's ticketing platform made our event management so
                    much easier. We sold over 1,000 tickets seamlessly and the
                    check-in process was incredibly smooth."
                  </p>
                  <p className="text-sm font-medium" data-id="element-3664">
                    - James Omondi, Event Director
                  </p>
                </div>
              </div>
            </div>
            <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6" data-id="element-3665">
              <div className="flex items-start" data-id="element-3666">
                <div className="w-12 h-12 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-3667">
                  <span className="text-lg font-bold" data-id="element-3668">NC</span>
                </div>
                <div data-id="element-3669">
                  <h3 className="font-bold mb-1" data-id="element-3670">Nairobi Comedy Club</h3>
                  <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-3671">
                    "The analytics provided by JoinToday helped us understand
                    our audience better and tailor our marketing efforts. Our
                    ticket sales increased by 40% compared to previous events."
                  </p>
                  <p className="text-sm font-medium" data-id="element-3672">
                    - Grace Wanjiku, Marketing Manager
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* CTA */}
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 text-center" data-id="element-3673">
          <h2 className="text-xl font-bold mb-2" data-id="element-3674">
            Ready to Simplify Your Event Ticketing?
          </h2>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4 max-w-lg mx-auto" data-id="element-3675">
            Join hundreds of event organizers who trust JoinToday for their
            ticketing needs. Get started today and focus on what matters most -
            creating amazing events.
          </p>
          <div className="flex justify-center" data-id="element-3676">
            <Link to="/register" className="px-6 py-2 bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 rounded-md mr-3" data-id="element-3677">
              Start Selling Tickets
            </Link>
            <a href="mailto:sales@jointoday.co.ke" className="px-6 py-2 border border-gray-300 dark:border-gray-600 rounded-md" data-id="element-3678">
              Contact Sales
            </a>
          </div>
        </div>
      </div>
    </div>;
};
export default TicketingServices;